import { render, staticRenderFns } from "./embed-able.vue?vue&type=template&id=ee5d4d28&"
import script from "./embed-able.vue?vue&type=script&lang=js&"
export * from "./embed-able.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports